import React from 'react';
import Description from '../components/Description';
import NextMeetings from '../components/NextMeetings';
import Members from '../components/Members';
import ReadBooks from '../components/ReadBooks';

const Dashboard = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Welcome to Munich Girls Book Club</h1>
        <div className="grid grid-flow-row grid-cols-1 gap-4 px-3 pt-4 pb-8 md:gap-6 md:px-6 md:grid-cols-2 lg:grid-cols-12">
          <Description />
          <NextMeetings />
          <Members />
          <ReadBooks />
        </div>
      </main>
    </div>
  );
};

export default Dashboard;